import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, exhaustMap, tap } from 'rxjs/operators';

import { TodoService } from '../../components/todo/todo.service';
import { deleteOneSucccess, getAllSuccess, loadTodosFromPage, editOne, editOneSuccess, createOne, createOneSucccess, deleteOne } from './todo.actions';
import { Todo } from '../../models/todo';
import { Router } from '@angular/router';

@Injectable()
export class TodoEffects {

    constructor(
        private todoService: TodoService,
        private actions$: Actions,
        private router: Router,
    ) {}

    loadTodos$ = createEffect(() => {

        return this.actions$.pipe(
            ofType(loadTodosFromPage),
            exhaustMap(() => this.todoService.getAll()
                .pipe(
                    map((todoList: Todo[]) => getAllSuccess({ todoList })),
                ))
            );
        }
    );

    editTodo$ = createEffect(() => {

        return this.actions$.pipe(
            ofType(editOne),
            exhaustMap(({ todo }) => this.todoService.editOne(todo)
                .pipe(
                    map((todo) => editOneSuccess({ todo })),
                ))
            );
        }
    );

    deleteTodo$ = createEffect(() => {

        return this.actions$.pipe(
            ofType(deleteOne),
            exhaustMap(({ todo }) => this.todoService.deleteOne(todo)
                .pipe(
                    map((todo) => deleteOneSucccess({ todo })),
                ))
            );
        }
    );

    createTodo$ = createEffect(() => {

        return this.actions$.pipe(
            ofType(createOne),
            exhaustMap(({ todo }) => this.todoService.createOne(todo)
                .pipe(
                    map((todo) => createOneSucccess({ todo })),
                ))
            );
        }
    );

    navigateToTodos$ = createEffect(() => {

        return this.actions$.pipe(
            ofType(
                deleteOneSucccess,
                editOneSuccess,
                createOneSucccess,
            ),
            tap(() => this.router.navigate(['/todos']))
        )
    }, { dispatch: false });
}